import React, { Component } from 'react';
import { connect } from 'react-redux';
import MyBillingWrapper from './style';
import basicStyle from '../../config/basicStyle';
import appActions from '../../redux/app/actions';
const { appSelected, searchTermUpdated } = appActions;
import { bindActionCreators } from 'redux'
import { Row, Col } from 'antd';
import ContentHolder from '../../components/utility/contentHolder';
import AEImg from '../../image/card-types/american_express.png';
import AndroidPayImg from '../../image/card-types/android_pay.png';
import ApplePayImg from '../../image/card-types/apple_pay.png';
import VISAImg from '../../image/card-types/visa.png';
import MasterImg from '../../image/card-types/master.png';
import Tooltip from '../../components/uielements/tooltip';
import { Formik, FieldArray } from 'formik';
import { CardElement, injectStripe, Elements, StripeProvider} from 'react-stripe-elements';

class _UpdateCreditCardForm extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return <div style={{width:'100%'}}>
      <CardElement/>
    </div>
  }
}

const UpdateCreditCardForm = injectStripe(_UpdateCreditCardForm)

class MyBilling extends Component {

  constructor(props) {
    super(props)
    this.state = {
      billingInfoEditable: false,
      creditCardEditable: false
    }
    this.onClickBillingInfoEdit = this.onClickBillingInfoEdit.bind(this);
    this.onClickCreditCardEdit = this.onClickCreditCardEdit.bind(this);
  }
  
  componentWillUpdate(){
    console.log( ' componentWillUpdate')
    //check difference
    
  }
  componentWillReceiveProps(){
    console.log( ' componentWillReceiveProps')
  }

  

  createCampaignFake(campaign){
  }


  onClickBillingInfoEdit() {
    this.setState({
      billingInfoEditable: !this.state.billingInfoEditable
    })
  }

  onClickCreditCardEdit() {
    this.setState({
      creditCardEditable: !this.state.creditCardEditable
    })
  }

  render() {
    // console.log( this.props)
    // const { appDetail } = this.state;
    // const { searchTerm, campaign, currentApp, secondApp} = this.props;    
    // const { rowStyle, colStyle } = basicStyle;
    const { rowStyle, colStyle } = basicStyle;

    return (
      <MyBillingWrapper>
        <div className="account-menu">
          <ul>
            <li>
              <a href="account">我的帐户</a>
            </li>
            
            <li>
              <a href="billing" className="active">付款资料</a>
            </li>
          </ul>
        </div>

        <div className="main">
          <div className="info">
            <h2>
              <span>信用卡资料</span>
              {this.state.creditCardEditable ? null : (
                <a href="javascript:void(0)" onClick={this.onClickCreditCardEdit}>修改</a>
              )}
            </h2>
            <Formik
              initialValues={{
                cardNumber: '**** **** **** ****',
                expiryDate: '24/24',
                cvc: '***'
              }}
              validate={values=>{
              }}
              onSubmit={(values, actions)=>{
                console.log('update card details');
                console.table(values);
                this.setState({
                  creditCardEditable: false
                })
              }}
              render={({ handleSubmit, handleChange, handleBlur, setFieldValue, values, errors, dirty, touched}) => {
                return (
                  <form onSubmit={handleSubmit}>
                  {this.state.creditCardEditable ? null : (
                    <Row style={rowStyle}>
                      <Col md={4} sm={24} xs={24}>
                        <img style={{}} className="card-type" src={VISAImg} alt="visa"/>
                      </Col>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                          <div className="inputWrapper">
                            <label htmlFor="cardNumber">信用卡号码</label>

                            <div className={`FormTextInput ${!this.state.creditCardEditable ? "noteditable" : ""}`}>
                              <input disabled type="text" name="cardNumber" value={values.cardNumber}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                      <Col md={4} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                            <div className="inputWrapper">
                              <label htmlFor="expiryDate">到期日</label>

                              <div className={`FormTextInput ${!this.state.creditCardEditable ? "noteditable" : ""}`}>
                                <input disabled type="text" name="expiryDate" value={values.expiryDate}/>
                              </div>
                            </div>
                          </ContentHolder>
                      </Col>
                      <Col md={4} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                            <div className="inputWrapper">
                              <label htmlFor="cvc">CVC
                                {/* <Tooltip 
                                  title={"CVC"}>
                                  {"?"}
                                </Tooltip> */}
                              </label>
                              <div className={`FormTextInput ${!this.state.creditCardEditable ? "noteditable" : ""}`}>
                                <input disabled type="text" name="cvc" value={values.cvc}/>
                              </div>
                            </div>
                          </ContentHolder>
                      </Col>
                    </Row>
                  )}
                    {this.state.creditCardEditable ? (
                      <Row style={rowStyle}>
                        <StripeProvider apiKey="pk_test_6pRNASCoBOKtIshFeQd4XMUh">
                          <Elements>
                            <UpdateCreditCardForm/>
                          </Elements>
                        </StripeProvider>
                      </Row>
                    ) : null}
                    {this.state.creditCardEditable ? (
                      <Row style={rowStyle}>
                        <Col md={3} sm={4} xs={4} style={colStyle}>
                          <img className="card-type" src={VISAImg} alt="visa"/>
                        </Col>
                        <Col md={3} sm={4} xs={4} style={colStyle}>
                          <img className="card-type" src={MasterImg} alt="master"/>
                        </Col>
                        <Col md={3} sm={4} xs={4} style={colStyle}>
                          <img className="card-type" src={AEImg} alt="ae"/>
                        </Col>
                        <Col md={3} sm={4} xs={4} style={colStyle}>
                          <img className="card-type" src={ApplePayImg} alt="apple-pay"/>
                        </Col>
                        <Col md={3} sm={4} xs={4} style={colStyle}>
                          <img className="card-type" src={AndroidPayImg} alt="android-pay"/>
                        </Col>
                      </Row>
                    ) : null}
                    {this.state.creditCardEditable? (
                      <Row style={rowStyle}>
                        <button className="btn-savechanges" type="submit">保存</button>
                      </Row>
                    ) : null}
                  </form>
                );
              }}
            />
            <h2>
              <span>帐单资料</span>
              {this.state.billingInfoEditable ? null : (
                <a href="javascript:void(0)" onClick={this.onClickBillingInfoEdit}>修改</a>
              )}
            </h2>
            <Formik
              initialValues={{
                  firstName: 'Sam',
                  lastName: 'Harris',
                  addr1: '4/F ABC House',
                  addr2: '23 DEF Road',
                  region1: 'Tsim Sha Tsui',
                  region2: '',
                  zipOrPostalCode: '',
                  country: 'Hong Kong'
              }}
              validate={values=>{
              }}
              onSubmit={(values, actions)=>{
                console.log('my billing address');
                console.table(values);
                this.setState({
                  billingInfoEditable: false
                })
              }}
              render={({ handleSubmit, handleChange, handleBlur, setFieldValue, values, errors, dirty, touched}) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <Row style={rowStyle}>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                          <div className="inputWrapper">
                            <label htmlFor="firstName">昵称</label>

                            <div className={`FormTextInput ${!this.state.billingInfoEditable ? "noteditable" : ""}`}>
                              <input disabled={!this.state.billingInfoEditable} type="text" name="firstName" value={values.firstName} onChange={handleChange}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                          <div className="inputWrapper" hidden>
                            <label htmlFor="lastName">Last Name</label>

                            <div className={`FormTextInput ${!this.state.billingInfoEditable ? "noteditable" : ""}`}>
                              <input disabled={!this.state.billingInfoEditable} type="text" name="lastName" value={values.lastName} onChange={handleChange}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                    </Row>
                    <Row style={rowStyle}>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                          <div className="inputWrapper">
                            <label htmlFor="addr1">地址</label>

                            <div className={`FormTextInput ${!this.state.billingInfoEditable ? "noteditable" : ""}`}>
                              <input disabled={!this.state.billingInfoEditable} type="text" name="addr1" value={values.addr1} onChange={handleChange}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                      <Col md={12} sm={24} xs={24} style={colStyle} hidden>
                        <ContentHolder>
                          <div className="inputWrapper">
                            <label htmlFor="addr2"></label>

                            <div className={`FormTextInput ${!this.state.billingInfoEditable ? "noteditable" : ""}`}>
                              <input disabled={!this.state.billingInfoEditable} type="text" name="addr2" value={values.addr2} onChange={handleChange}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                    </Row>
                    <Row style={rowStyle} hidden>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                          <div className="inputWrapper">
                            <label htmlFor="region1">City/Town/District</label>

                            <div className={`FormTextInput ${!this.state.billingInfoEditable ? "noteditable" : ""}`}>
                              <input disabled={!this.state.billingInfoEditable} type="text" name="region1" value={values.region1} onChange={handleChange}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                          <div className="inputWrapper">
                            <label htmlFor="region2">State/Province/Country/Region</label>

                            <div className={`FormTextInput ${!this.state.billingInfoEditable ? "noteditable" : ""}`}>
                              <input disabled={!this.state.billingInfoEditable} type="text" name="region2" value={values.region2} onChange={handleChange}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                    </Row>
                    <Row style={rowStyle}>
                      <Col md={12} sm={24} xs={24} style={colStyle} hidden>
                        <ContentHolder>
                          <div className="inputWrapper">
                            <label htmlFor="zipOrPostalCode">ZIP/Postal Code</label>

                            <div className={`FormTextInput ${!this.state.billingInfoEditable ? "noteditable" : ""}`}>
                              <input disabled={!this.state.billingInfoEditable} type="text" name="zipOrPostalCode" value={values.zipOrPostalCode} onChange={handleChange}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                      <Col md={12} sm={24} xs={24} style={colStyle}>
                        <ContentHolder>
                          <div className="inputWrapper">
                            <label htmlFor="country">城市</label>

                            <div className={`FormTextInput ${!this.state.billingInfoEditable ? "noteditable" : ""}`}>
                              <input disabled={!this.state.billingInfoEditable} type="text" name="country" value={values.country} onChange={handleChange}/>
                            </div>
                          </div>
                        </ContentHolder>
                      </Col>
                    </Row>
                    {this.state.billingInfoEditable? (
                      <Row style={rowStyle}>
                        <button className="btn-savechanges" type="submit">保存</button>
                      </Row>
                     ) : null
                    }
                  </form>
                );
              }}
            />
          </div>
        </div>
      </MyBillingWrapper>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { 
    setApp: (app) => dispatch(appSelected(app)),
    appSelected: bindActionCreators(appSelected, dispatch),
    searchTermUpdated:  bindActionCreators(searchTermUpdated, dispatch) ,

  }
}
function mapStateToProps(state) {
  // const campaign  = state.get('deep').campaign;
  return { 
    search: state.get('search'),
    // campaign: campaign,
    currentApp: state.getIn( ['App', 'currentApp']),
    secondApp: state.getIn( ['App', 'secondApp']),
    searchTerm: state.getIn( ['App', 'searchTerm']),

  }
}



export default  connect(
  mapStateToProps,
  mapDispatchToProps
)(MyBilling);



// WEBPACK FOOTER //
// ./src/containers/MyBilling/index.js